// @generated by protoc-gen-es v2.12.1 with parameter "target=ts,json_types=true"
// @generated from file integrations/v1/proxy.proto (package integrations.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { StructJson, Value, ValueJson } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_struct } from "@bufbuild/protobuf/wkt";
import type { JsonObject, Message } from "@bufbuild/protobuf";

/**
 * Describes the file integrations/v1/proxy.proto.
 */
export const file_integrations_v1_proxy: GenFile =
	/*@__PURE__*/
	fileDesc(
		"ChtpbnRlZ3JhdGlvbnMvdjEvcHJveHkucHJvdG8SD2ludGVncmF0aW9ucy52MSIeCgxIZWFkZXJWYWx1ZXMSDgoGdmFsdWVzGAEgAygJIvkCCgxQcm94eVJlcXVlc3QSGwoTd29ya3NwYWNlX3RlbmFudF9pZBgBIAEoCRISCgp0YXJnZXRfdXJsGAIgASgJEjMKBm1ldGhvZBgDIAEoDjIjLmludGVncmF0aW9ucy52MS5Qcm94eVJlcXVlc3RNZXRob2QSOwoHaGVhZGVycxgEIAMoCzIqLmludGVncmF0aW9ucy52MS5Qcm94eVJlcXVlc3QuSGVhZGVyc0VudHJ5EjIKDHF1ZXJ5X3BhcmFtcxgFIAEoCzIXLmdvb2dsZS5wcm90b2J1Zi5TdHJ1Y3RIAIgBARIpCgRib2R5GAYgASgLMhYuZ29vZ2xlLnByb3RvYnVmLlZhbHVlSAGIAQEaTQoMSGVhZGVyc0VudHJ5EgsKA2tleRgBIAEoCRIsCgV2YWx1ZRgCIAEoCzIdLmludGVncmF0aW9ucy52MS5IZWFkZXJWYWx1ZXM6AjgBQg8KDV9xdWVyeV9wYXJhbXNCBwoFX2JvZHkiygEKDVByb3h5UmVzcG9uc2USEwoLaHR0cF9zdGF0dXMYASABKAUSPAoHaGVhZGVycxgCIAMoCzIrLmludGVncmF0aW9ucy52MS5Qcm94eVJlc3BvbnNlLkhlYWRlcnNFbnRyeRIkCgRkYXRhGAMgASgLMhYuZ29vZ2xlLnByb3RvYnVmLlZhbHVlEhAKCHJhd19ib2R5GAQgASgMGi4KDEhlYWRlcnNFbnRyeRILCgNrZXkYASABKAkSDQoFdmFsdWUYAiABKAk6AjgBKtYBChJQcm94eVJlcXVlc3RNZXRob2QSJAogUFJPWFlfUkVRVUVTVF9NRVRIT0RfVU5TUEVDSUZJRUQQABIcChhQUk9YWV9SRVFVRVNUX01FVEhPRF9HRVQQARIdChlQUk9YWV9SRVFVRVNUX01FVEhPRF9QT1NUEAISHAoYUFJPWFlfUkVRVUVTVF9NRVRIT0RfUFVUEAMSHgoaUFJPWFlfUkVRVUVTVF9NRVRIT0RfUEFUQ0gQBBIfChtQUk9YWV9SRVFVRVNUX01FVEhPRF9ERUxFVEUQBWIGcHJvdG8z",
		[file_google_protobuf_struct],
	);

/**
 * @generated from message integrations.v1.HeaderValues
 */
export type HeaderValues = Message<"integrations.v1.HeaderValues"> & {
	/**
	 * @generated from field: repeated string values = 1;
	 */
	values: string[];
};

/**
 * @generated from message integrations.v1.HeaderValues
 */
export type HeaderValuesJson = {
	/**
	 * @generated from field: repeated string values = 1;
	 */
	values?: string[];
};

/**
 * Describes the message integrations.v1.HeaderValues.
 * Use `create(HeaderValuesSchema)` to create a new message.
 */
export const HeaderValuesSchema: GenMessage<HeaderValues, { jsonType: HeaderValuesJson }> = /*@__PURE__*/ messageDesc(file_integrations_v1_proxy, 0);

/**
 * @generated from message integrations.v1.ProxyRequest
 */
export type ProxyRequest = Message<"integrations.v1.ProxyRequest"> & {
	/**
	 * @generated from field: string workspace_tenant_id = 1;
	 */
	workspaceTenantId: string;

	/**
	 * @generated from field: string target_url = 2;
	 */
	targetUrl: string;

	/**
	 * @generated from field: integrations.v1.ProxyRequestMethod method = 3;
	 */
	method: ProxyRequestMethod;

	/**
	 * @generated from field: map<string, integrations.v1.HeaderValues> headers = 4;
	 */
	headers: { [key: string]: HeaderValues };

	/**
	 * @generated from field: optional google.protobuf.Struct query_params = 5;
	 */
	queryParams?: JsonObject | undefined;

	/**
	 * @generated from field: optional google.protobuf.Value body = 6;
	 */
	body?: Value | undefined;
};

/**
 * @generated from message integrations.v1.ProxyRequest
 */
export type ProxyRequestJson = {
	/**
	 * @generated from field: string workspace_tenant_id = 1;
	 */
	workspaceTenantId?: string;

	/**
	 * @generated from field: string target_url = 2;
	 */
	targetUrl?: string;

	/**
	 * @generated from field: integrations.v1.ProxyRequestMethod method = 3;
	 */
	method?: ProxyRequestMethodJson;

	/**
	 * @generated from field: map<string, integrations.v1.HeaderValues> headers = 4;
	 */
	headers?: { [key: string]: HeaderValuesJson };

	/**
	 * @generated from field: optional google.protobuf.Struct query_params = 5;
	 */
	queryParams?: StructJson;

	/**
	 * @generated from field: optional google.protobuf.Value body = 6;
	 */
	body?: ValueJson;
};

/**
 * Describes the message integrations.v1.ProxyRequest.
 * Use `create(ProxyRequestSchema)` to create a new message.
 */
export const ProxyRequestSchema: GenMessage<ProxyRequest, { jsonType: ProxyRequestJson }> = /*@__PURE__*/ messageDesc(file_integrations_v1_proxy, 1);

/**
 * @generated from message integrations.v1.ProxyResponse
 */
export type ProxyResponse = Message<"integrations.v1.ProxyResponse"> & {
	/**
	 * @generated from field: int32 http_status = 1;
	 */
	httpStatus: number;

	/**
	 * @generated from field: map<string, string> headers = 2;
	 */
	headers: { [key: string]: string };

	/**
	 * @generated from field: google.protobuf.Value data = 3;
	 */
	data?: Value | undefined;

	/**
	 * @generated from field: bytes raw_body = 4;
	 */
	rawBody: Uint8Array;
};

/**
 * @generated from message integrations.v1.ProxyResponse
 */
export type ProxyResponseJson = {
	/**
	 * @generated from field: int32 http_status = 1;
	 */
	httpStatus?: number;

	/**
	 * @generated from field: map<string, string> headers = 2;
	 */
	headers?: { [key: string]: string };

	/**
	 * @generated from field: google.protobuf.Value data = 3;
	 */
	data?: ValueJson;

	/**
	 * @generated from field: bytes raw_body = 4;
	 */
	rawBody?: string;
};

/**
 * Describes the message integrations.v1.ProxyResponse.
 * Use `create(ProxyResponseSchema)` to create a new message.
 */
export const ProxyResponseSchema: GenMessage<ProxyResponse, { jsonType: ProxyResponseJson }> = /*@__PURE__*/ messageDesc(file_integrations_v1_proxy, 2);

/**
 * @generated from enum integrations.v1.ProxyRequestMethod
 */
export enum ProxyRequestMethod {
	/**
	 * @generated from enum value: PROXY_REQUEST_METHOD_UNSPECIFIED = 0;
	 */
	UNSPECIFIED = 0,

	/**
	 * @generated from enum value: PROXY_REQUEST_METHOD_GET = 1;
	 */
	GET = 1,

	/**
	 * @generated from enum value: PROXY_REQUEST_METHOD_POST = 2;
	 */
	POST = 2,

	/**
	 * @generated from enum value: PROXY_REQUEST_METHOD_PUT = 3;
	 */
	PUT = 3,

	/**
	 * @generated from enum value: PROXY_REQUEST_METHOD_PATCH = 4;
	 */
	PATCH = 4,

	/**
	 * @generated from enum value: PROXY_REQUEST_METHOD_DELETE = 5;
	 */
	DELETE = 5,
}

/**
 * @generated from enum integrations.v1.ProxyRequestMethod
 */
export type ProxyRequestMethodJson = "PROXY_REQUEST_METHOD_UNSPECIFIED" | "PROXY_REQUEST_METHOD_GET" | "PROXY_REQUEST_METHOD_POST" | "PROXY_REQUEST_METHOD_PUT" | "PROXY_REQUEST_METHOD_PATCH" | "PROXY_REQUEST_METHOD_DELETE";

/**
 * Describes the enum integrations.v1.ProxyRequestMethod.
 */
export const ProxyRequestMethodSchema: GenEnum<ProxyRequestMethod, ProxyRequestMethodJson> = /*@__PURE__*/ enumDesc(file_integrations_v1_proxy, 0);
